import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

import style from './index.module.scss';

@Component({
  name: 'ZhenxiangMemberCard',
})
export default class ZhenxiangMemberCard extends Vue {
    @Prop({
      type: Number,
    })
    private marketPrice!: number;

    /** 自营臻享卡权益说明 */
    private render() {
      return (
        <div class={style.rightsItems}>
          <div class={style.rightsItem}>
            臻有钱提供专享
            <span class={style.rightsValue}>定制化</span>
            权益
          </div>
          <div class={style.rightsItem}>
            尊享最高价值
            <span class={style.rightsValue}>192元</span>
            哈啰定制生活权益
          </div>
          <div class={style.rightsItem}>
            尽享
            <span class={style.rightsValue}>{this.marketPrice}元</span>
            臻享生活权益
          </div>
        </div>
      );
    }
}
